import React from 'react';
import { Link } from 'react-router-dom';
import './Welcome.css';

class WelcomePage extends React.Component {
  componentDidMount() {
    document.querySelector('body').classList.remove('sucesso');
    document.querySelector('body').classList.add('welcome');
  }

  renderData() {
    return (
      <div className='align'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='450'
          height='250'
          viewBox='0 0 119.51 34.218'
        >
          <g id='logo' transform='translate(-216.821 -297.422)'>
            <path
              id='Path_32'
              data-name='Path 32'
              d='M255.916,330.361l-39.1,27.375v2.281l39.1-27.375Z'
              transform='translate(0 -28.377)'
              fill='#fafaf2'
            />
            <path
              id='Path_33'
              data-name='Path 33'
              d='M255.916,297.422l-26.063,18.25h0L216.821,324.8v2.281l39.1-27.375Z'
              transform='translate(0)'
              fill='#fafaf2'
            />
            <path
              id='Path_34'
              data-name='Path 34'
              d='M229.853,363.3l-13.032,9.125v2.281l13.032-9.125Z'
              transform='translate(0 -56.754)'
              fill='#fafaf2'
            />
            <path
              id='Path_35'
              data-name='Path 35'
              d='M229.853,396.24l-13.032,9.125v2.281l13.032-9.125Z'
              transform='translate(0 -85.131)'
              fill='#fafaf2'
            />
            <path
              id='Path_36'
              data-name='Path 36'
              d='M418.022,429.18,404.991,438.3v2.281l13.032-9.125Z'
              transform='translate(-162.106 -113.508)'
              fill='#fafaf2'
            />
            <path
              id='Path_37'
              data-name='Path 37'
              d='M336.969,363.3l-26.063,18.25v2.281l26.063-18.25Z'
              transform='translate(-81.053 -56.754)'
              fill='#fafaf2'
            />
            <path
              id='Path_38'
              data-name='Path 38'
              d='M404.991,471.244v2.281l13.032-9.125v-2.281Z'
              transform='translate(-162.106 -141.885)'
              fill='#fafaf2'
            />
            <path
              id='Path_39'
              data-name='Path 39'
              d='M336.969,396.24l-26.063,18.25v2.281l26.063-18.25Z'
              transform='translate(-81.053 -85.131)'
              fill='#fafaf2'
            />
            <path
              id='Path_40'
              data-name='Path 40'
              d='M557.276,416.041h2.593v-6.235a4.245,4.245,0,0,0-.279-1.554,3.45,3.45,0,0,0-.785-1.2,3.489,3.489,0,0,0-1.216-.778,4.371,4.371,0,0,0-1.573-.277,4.43,4.43,0,0,0-1.857.372,3.287,3.287,0,0,0-1.461,1.3l-.018.03-.018-.029a3.7,3.7,0,0,0-3.227-1.673,3.84,3.84,0,0,0-1.592.316,3.028,3.028,0,0,0-1.28,1.094l-.039.059v-1.205h-2.532v9.782h2.6v-5.363a2.285,2.285,0,0,1,.62-1.681,1.893,1.893,0,0,1,.669-.421,2.317,2.317,0,0,1,.812-.14,2.176,2.176,0,0,1,.817.146,1.607,1.607,0,0,1,.61.429,2.423,2.423,0,0,1,.511,1.647v5.383h2.6v-5.363a2.285,2.285,0,0,1,.62-1.681,1.889,1.889,0,0,1,.669-.421,2.315,2.315,0,0,1,.811-.14,2.161,2.161,0,0,1,.812.146,1.619,1.619,0,0,1,.611.429,2.416,2.416,0,0,1,.515,1.647Z'
              transform='translate(-281.855 -93.534)'
              fill='#fafaf2'
            />
            <path
              id='Path_41'
              data-name='Path 41'
              d='M674.616,405.995a5.168,5.168,0,0,0,0,10.3,3.93,3.93,0,0,0,1.727-.37,3.488,3.488,0,0,0,1.2-.96l.038-.047v1.124h2.543v-9.782h-2.543v1.124l-.038-.047A3.582,3.582,0,0,0,674.616,405.995Zm.487,7.879a2.612,2.612,0,0,1-1.059-.214,2.349,2.349,0,0,1-.806-.584,3.042,3.042,0,0,1,0-3.862,2.354,2.354,0,0,1,.806-.584,2.732,2.732,0,0,1,2.1-.007,2.36,2.36,0,0,1,.808.572,3.044,3.044,0,0,1,0,3.9,2.359,2.359,0,0,1-.808.572A2.623,2.623,0,0,1,675.1,413.874Z'
              transform='translate(-390.307 -93.534)'
              fill='#fafaf2'
            />
            <path
              id='Path_42'
              data-name='Path 42'
              d='M766.689,416.041h2.6v-6.235a4.216,4.216,0,0,0-.282-1.554,3.462,3.462,0,0,0-1.989-1.981,4.184,4.184,0,0,0-1.531-.277,3.84,3.84,0,0,0-1.592.316,3.028,3.028,0,0,0-1.28,1.094l-.039.059v-1.205h-2.532v9.782h2.6v-5.363a2.285,2.285,0,0,1,.62-1.681,1.892,1.892,0,0,1,.669-.421,2.317,2.317,0,0,1,.812-.14,2.176,2.176,0,0,1,.816.146,1.607,1.607,0,0,1,.61.429,2.423,2.423,0,0,1,.511,1.647Z'
              transform='translate(-467.984 -93.534)'
              fill='#fafaf2'
            />
            <path
              id='Path_43'
              data-name='Path 43'
              d='M842.791,377.93a5.168,5.168,0,0,0,0,10.3,3.929,3.929,0,0,0,1.727-.37,3.487,3.487,0,0,0,1.2-.96l.038-.047v1.124H848.3V373.418H845.7v5.838l-.038-.046A3.552,3.552,0,0,0,842.791,377.93Zm.487,7.879a2.612,2.612,0,0,1-1.059-.214,2.346,2.346,0,0,1-.806-.584,3.042,3.042,0,0,1,0-3.862,2.35,2.35,0,0,1,.806-.584,2.732,2.732,0,0,1,2.1-.007,2.358,2.358,0,0,1,.808.572,3.044,3.044,0,0,1,0,3.9,2.355,2.355,0,0,1-.808.572A2.62,2.62,0,0,1,843.278,385.809Z'
              transform='translate(-535.188 -65.47)'
              fill='#fafaf2'
            />
            <path
              id='Path_44'
              data-name='Path 44'
              d='M928.563,405.995a5.168,5.168,0,0,0,0,10.3,3.928,3.928,0,0,0,1.727-.37,3.489,3.489,0,0,0,1.2-.96l.038-.047v1.124h2.543v-9.782h-2.543v1.124l-.038-.047A3.582,3.582,0,0,0,928.563,405.995Zm.487,7.879a2.612,2.612,0,0,1-1.059-.214,2.346,2.346,0,0,1-.806-.584,3.042,3.042,0,0,1,0-3.862,2.351,2.351,0,0,1,.806-.584,2.732,2.732,0,0,1,2.1-.007,2.359,2.359,0,0,1,.808.572,3.044,3.044,0,0,1,0,3.9,2.358,2.358,0,0,1-.808.572A2.622,2.622,0,0,1,929.05,413.874Z'
              transform='translate(-609.08 -93.534)'
              fill='#fafaf2'
            />
            <path
              id='Path_45'
              data-name='Path 45'
              d='M1019.3,411.135a6.194,6.194,0,0,0-.351-2.091,4.758,4.758,0,0,0-.974-1.623,4.313,4.313,0,0,0-1.5-1.051,4.936,4.936,0,0,0-1.93-.374,5.294,5.294,0,0,0-2.009.376,4.5,4.5,0,0,0-1.563,1.058,4.747,4.747,0,0,0-1.014,1.636,6.019,6.019,0,0,0-.361,2.11,5.793,5.793,0,0,0,.372,2.1,4.559,4.559,0,0,0,2.647,2.652,5.67,5.67,0,0,0,2.06.367,6.94,6.94,0,0,0,2.288-.36,5.4,5.4,0,0,0,1.869-1.11l-1.523-1.672a4.157,4.157,0,0,1-1.179.686,3.734,3.734,0,0,1-1.3.249,2.65,2.65,0,0,1-1.636-.491,2.491,2.491,0,0,1-.909-1.564l-.005-.026h6.974A7.733,7.733,0,0,0,1019.3,411.135Zm-7.011-.891,0-.026a2.579,2.579,0,0,1,.731-1.452,2.132,2.132,0,0,1,1.5-.533,2.02,2.02,0,0,1,1.419.518,2.613,2.613,0,0,1,.742,1.467l.005.026Z'
              transform='translate(-682.972 -93.534)'
              fill='#fafaf2'
            />
            <path
              id='Path_46'
              data-name='Path 46'
              d='M1025.231,370.923l-2.1-2.1-2.1,2.1-1.439-1.439,3.538-3.538,3.537,3.538Z'
              transform='translate(-691.581 -59.033)'
              fill='#fafaf2'
            />
          </g>
        </svg>

        <h1>Parabéns, você já concluiu o processo de Instalação!</h1>

        <p>
          Entretanto, para conseguir utilizar o aplicativo é necessário ser
          cliente da Mandaê, possuir Token e Customer Id e realizar a
          configuração necessária.
        </p>

        <p>
          Se você já é cliente Mandaê,{' '}
          <a
            href='https://youtu.be/c4LLFUy6Ieg'
            target='_blank'
            rel='noreferrer'
          >
            clique aqui
          </a>{' '}
          para saber como configurar o aplicativo e clique em{' '}
          <a
            href="javascript:window.top.postMessage('sucesso', '*');"
            className='primary'
          >
            Finalizar
          </a>
          .
        </p>

        <p>
          Se você ainda não é cliente da mandaê clique em{' '}
          <Link to='/formulario' className='primary'>
            Continuar
          </Link>
        </p>
      </div>
    );
  }

  render() {
    return this.renderData();
  }
}

export default WelcomePage;
